
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5 13.75a1.75 1.75 0 100-3.5 1.75 1.75 0 000 3.5zM13.75 12a1.75 1.75 0 11-3.5 0 1.75 1.75 0 013.5 0zm7 0a1.75 1.75 0 11-3.5 0 1.75 1.75 0 013.5 0z"}})])
          )
        }
      }
    